export type SemanticZoomLevel = 'far' | 'medium' | 'close'

export function semanticZoomLevel(projectedRackWidthPx: number): SemanticZoomLevel {
  if (projectedRackWidthPx < 12) return 'far'
  if (projectedRackWidthPx < 40) return 'medium'
  return 'close'
}

export function rackIsVisible(
  rack: { x: number; y: number; w: number; h: number },
  viewport: { x: number; y: number; w: number; h: number },
  focused: boolean,
): boolean {
  return focused || (
    rack.x < viewport.x + viewport.w && rack.x + rack.w > viewport.x
    && rack.y < viewport.y + viewport.h && rack.y + rack.h > viewport.y
  )
}
